// ./src/components/features/Applications/ApplicationDetailRow.tsx
//
// One "label → value" line in an application drawer — shared by the sponsorship (#A4.5) and volunteer (#A4.6)
// inboxes so their drawers read the same way.
import React from "react";
import { Group, Stack, Text } from "@mantine/core";

export const ApplicationDetailRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <Group justify="space-between" align="flex-start" wrap="nowrap" gap="md">
    <Text size="md" c="dimmed" style={{ flexShrink: 0 }}>
      {label}
    </Text>
    <Stack gap={0} style={{ minWidth: 0, alignItems: "flex-end", textAlign: "right" }}>
      {children}
    </Stack>
  </Group>
);
